import { FC } from 'react'
import { connect } from 'react-redux'
import { Field } from 'redux-form'
import { State } from 'interfaces/state'
import { Option, InputTheme, QAMarked } from 'interfaces/component'
import SelectWrapped from 'components/atoms/inputs/OldSelectWrapped'
import * as isNumber from 'lodash/isNumber'
import { PreventScrollOptional } from 'components/features/pfm/PreventScroll/PreventScrollOptional'

export type CarFieldOwnProps = QAMarked & {
  label: string
  name: string
  theme?: InputTheme
}

export type CarFieldStateProps = {
  options: Option<number>[]
  isLoading: boolean
}

type CarModelFieldOwnProps = CarFieldOwnProps & {
  make: number | null
}

type CarYearFieldOwnProps = CarFieldOwnProps & {
  make: number | null
  model: number | null
}

type CarFieldProps = CarFieldStateProps & CarFieldOwnProps

const CarField: FC<CarFieldProps> = ({ name, label, options, theme, isLoading, qaMarker }) => (
  <PreventScrollOptional
    allowScroll
    isWrapped={ options.length !== 0 }
  >
    <Field
      name={ name }
      props={{
        theme, label, options, qaMarker, isLoading,
      }}
      component={ SelectWrapped }
    />
  </PreventScrollOptional>
)

export const CarMakeField = connect<CarFieldStateProps, {}, CarFieldOwnProps>(
  ({ data }: State): CarFieldStateProps => ({
    options: data.property.carMakes.map(({ id, name }) => ({ label: name, value: id })),
    isLoading: false,
  })
)(CarField)

export const CarModelField = connect<CarFieldStateProps, {}, CarModelFieldOwnProps>(
  ({ data }: State, { make }: CarModelFieldOwnProps): CarFieldStateProps => {
    const carModels = (isNumber(make) && data.property.carModels[make]) || []

    return {
      options: carModels.map(({ id, name }) => ({ label: name, value: id })),
      isLoading: isNumber(make) && carModels.length === 0,
    }
  }
)(CarField)

export const CarYearField = connect<CarFieldStateProps, {}, CarYearFieldOwnProps>(
  ({ data }: State, { make, model }: CarYearFieldOwnProps) => {
    const carModels = (isNumber(make) && data.property.carModels[make]) || []
    const selectedModel = carModels.find(({ id }) => id === model)
    const years = selectedModel ? selectedModel.years : []

    return {
      options: years.map((item) => ({
        label: item.toString(),
        value: item,
      })),
      isLoading: isNumber(make) && isNumber(model) && years.length === 0,
    }
  }
)(CarField)
